import React, { useEffect, useRef, useState } from 'react';
import { DatePicker, Drawer, Modal, Popconfirm, Radio, Space, Switch, Table, Typography} from 'antd';
import type { TableColumnsType, TableProps } from 'antd';
import { Button, Form, Input, Select, Card } from 'antd';

import {
  CheckOutlined,
  ExclamationCircleOutlined,
  FileExcelOutlined ,
  CheckCircleOutlined,
  ReloadOutlined
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { DataTable } from '../common/DataTable';
import Column from 'antd/es/table/Column';
import { formatDateInTimeZone, removeNullQueryParam } from '../utils/CommonFn';
import TooltipParagraph from '../common/TooltipParagraph';
import { getMasterTypeSelectorValue } from '../common/slice-master';
import { use } from 'echarts';
import ticketInventory, { deleteFileByIdAndComponentName, downloadPreviewExcel, updateTicketsStatusForPreviewPage } from './slice-ticketInventory';
import { PreAuthz } from '../security/Authz';
import { MasterSelect } from '../common/MasterSelect';
import { stat } from 'fs';
import { useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';


const TicketStatus = {Pending:"Pending",Approved:"Approved",Rejected:"Rejected",OnHold :"ON_HOLD", Void :"Void"} as any;

const TicketStatusReverse = { } as any;

Object.keys(TicketStatus).forEach((e:any)=>{
  TicketStatusReverse[TicketStatus[e]] = e
});

const StatusRadioGroup = Object.keys(TicketStatus).map((e:any)=><Radio.Button value={TicketStatus[e]}>{e}</Radio.Button>)


const  buildParam = (searchParams:any, obj:any) => {
  let objd =  {
    productid: obj.productid || searchParams.get('productid') || '',
    pnr: obj.pnr || searchParams.get('pnr') || '',
    status: obj.status || (searchParams.get('status') || 'Pending')
  }
  if((obj.expiry_date || searchParams.get('expiry_date')) === null)
  return objd;

  return {...objd, expiry_date: obj.expiry_date || searchParams.get('expiry_date')}
}


const AdvanceFilter = ({open, onClose} : any) => {
  
  const [form] = Form.useForm();

  const [searchParams, setSearchParams] = useSearchParams();
  const prodid = searchParams.get('productid')
  return <Modal open={open} onCancel={onClose} className='doenloadPDFModal'
  width={600}
    title={'Advance Filter'}
    footer={(_, { OkBtn, CancelBtn }) => (
      <Button 
      type="primary" htmlType="submit"
      onClick={() => 
       {
        form
          .validateFields()
          .then((e) => {
            e.expiry_date = e.expiry_date  ? e.expiry_date.format('YYYY-MM-DD') : null;
            setSearchParams(buildParam(searchParams, e))
            onClose()
          });
       }} 
       >Filter</Button>)     }
    >

  
  <Form
  name="ticketuploadinventory"
  form={form}
  labelCol={{ span: 8 }}
  wrapperCol={{ span: 16 }}
  style={{ maxWidth: 600 }}
  initialValues={{
    productid: (prodid === '' || prodid === null ? '' :  +prodid) ,
    pnr: searchParams.get('pnr') || '',
    expiry_date:  searchParams.get('expiry_date') ? dayjs(searchParams.get('expiry_date')) : null,
  }}
  autoComplete="off"
>
    <Form.Item name="productid" label="Product Id" >
      <MasterSelect type='Trip Ticket Inventory' inlineSize={350} />
    </Form.Item>
    <Form.Item name="pnr" label="Enter pnr" >
        <Input type='text' placeholder='PNR' />
    </Form.Item>
    <Form.Item name="expiry_date" label="Select Expiry" >
        <DatePicker placeholder='Select Date' format={'DD-MM-YYYY'} />
    </Form.Item>
  </Form>
  </Modal>
}




const TicketListPopup = ({onClose, open} : any) => {
  const { inventoryData, ticketStatusUpdateloading, uploadEntryDeleteLoading, downloadPreviewExcelloading } = useSelector((state: any) => state.ticketInventory);
  const [searchParams, setSearchParams] = useSearchParams();

  const [status, setStatus] = useState<any>(searchParams.get('status') || 'Pending');
  const datatableref = useRef();
  const [state, setState] = useState<any>({selectedRows: [], filter: false});
  const [modal, contextHolder] = Modal.useModal();
 
  const isDiasableActionBtn =  state.selectedRows === undefined || state.selectedRows.length === 0;
  const dispatch = useDispatch();

  const downloadExcel = () => {
    dispatch(downloadPreviewExcel({id: open, status}))
  }

  useEffect(()=>{
    if(datatableref.current)
    (datatableref.current as any).refresh()
  }, [status])

  const markAsStatus = (status:any) => {

    modal.confirm({
      title: 'Confirmation for '+ TicketStatusReverse[status],
      icon: <ExclamationCircleOutlined />,
      content: 'After '+TicketStatusReverse[status]+' tickets, status will be updated and it will impact ticket inventory board',
      okText: 'Procced',
      onOk: (onOk) => {
        var d = state.selectedRows.map((e:any)=>({id: e, status: status }));
        dispatch(updateTicketsStatusForPreviewPage({status:status, body:d }))
        .then((e:any)=>{
            // refresh the table
            (datatableref.current as any).refresh()
            setState((st:any)=>({...st, selectedRows: []}))
            onOk();
        });
      },
      cancelText: 'Cancel',
    });
    // call api to update status
   


  }

  useEffect(() => {
    if(datatableref.current)
        (datatableref.current as any).refresh()
  }, [status, searchParams]);

  const handleStatusChange = (e: any) => {
    setSearchParams(buildParam(searchParams, {status: e.target.value}))
    setState((st:any)=>({...st, selectedRows: []}))
    setStatus(e.target.value);
  };

  return <Drawer 
  placement={'right'}
  open={open} 
  onClose={onClose  } 
  width={'calc(100% - 100px)'}
  title={
   <>
   {contextHolder}
    <PreAuthz allowedRoles='superadmin' hideResult={true} >
      { status === TicketStatus.Pending || status === TicketStatus.OnHold || status === TicketStatus.Void || status === TicketStatus.Rejected ? <Button disabled={isDiasableActionBtn} type='primary' style={{float: 'right', marginRight: 10}} onClick={()=>markAsStatus(TicketStatus.Approved)} loading={ticketStatusUpdateloading === TicketStatus.Approved}><CheckCircleOutlined /> Approve</Button>  : null}
    </PreAuthz>
    <PreAuthz allowedRoles='superadmin' hideResult={true} >
      { status === TicketStatus.Pending || status === TicketStatus.Approved ? <Button  disabled={isDiasableActionBtn} type='primary' danger style={{float: 'right', marginRight: 20}} onClick={()=>markAsStatus(TicketStatus.Rejected)} loading={ticketStatusUpdateloading === TicketStatus.Rejected}> Reject </Button>  : null}
    </PreAuthz>
    <PreAuthz allowedRoles='superadmin,ticketmanager' hideResult={true} >
      { status === TicketStatus.Pending || status === TicketStatus.Approved ? <Button  disabled={isDiasableActionBtn} style={{float: 'right', marginRight: 10}} onClick={()=>markAsStatus(TicketStatus.OnHold)} loading={ticketStatusUpdateloading === TicketStatus.OnHold}>On Hold </Button>  : null}
    </PreAuthz>    
    <PreAuthz allowedRoles='superadmin' hideResult={true} >  
      { status === TicketStatus.Pending || status === TicketStatus.Approved || status === TicketStatus.Rejected ? <Button   disabled={isDiasableActionBtn} style={{float: 'right', marginRight: 10}} onClick={()=>markAsStatus(TicketStatus.Void)} loading={ticketStatusUpdateloading === TicketStatus.Void}> Void </Button>  : null}
    </PreAuthz>
    <Button disabled={downloadPreviewExcelloading}  
    loading={downloadPreviewExcelloading} 
     style={{float: 'right', marginRight: 10, }}
      onClick={()=>downloadExcel()}><FileExcelOutlined  /> Export </Button>
   {/* <Button disabled={status== ''}  danger type='primary' style={{float: 'right', marginRight: 20}}  
   onClick={()=>{
    modal.confirm({
      title: 'Confirmation for rejection',
      icon: <ExclamationCircleOutlined />,
      content: 'After reject tickets will be deleted and uploaded file will be cleaned for system',
      okText: 'Procced',
      onOk: () => {
        // call approve api for rejection
      },
      cancelText: 'Cancel',
    });

   }}><CloseCircleOutlined /> Reject </Button>
   <Button type='primary' style={{float: 'right', marginRight: 20}} 
   
   onClick={()=>{
    modal.confirm({
      title: 'Confirm to procced',
      icon: <ExclamationCircleOutlined />,
      content: 'After approve tickets will be ready for download',
      okText: 'Procced',
      onOk: () => {
        // call approve api for approval
      },
      cancelText: 'Cancel',
    });

   }}><CheckCircleOutlined /> Approve </Button> */}
 
   {/* <Button   style={{float: 'right', marginRight: 20}}  onClick={()=>{}}><ReloadOutlined /> Refresh </Button> */}
          
   </> 
  
  
  }
  
  // footer={(_, { OkBtn, CancelBtn }) => (
  //   <>
  //     <CancelBtn />
  //   </>
  // )}
  destroyOnClose>
     
     
  
  <DataTable
            onRefresh={()=> setState((statea:any)=> ({ ...statea, selectedRows: []}))}
            checkboxProps={(record:any)=>({disabled: record.downloadPrimaryId})}
            selectedRows={status === '' ? undefined: state.selectedRows}
            onRowSlection={(selectedRow:any)=>setState((statea:any)=> ({ ...statea, selectedRows: selectedRow}))}
            ref={datatableref}
            title={<>
              <Radio.Group value={status} defaultValue={status} onChange={handleStatusChange}>
        <Radio.Button value="All">All</Radio.Button>
        {StatusRadioGroup}
        
      </Radio.Group>
            </>} 
            key="id" componentuniquekey="datatableuploadfilecontentlist" 
            lazyPagination={true}
            rowClassName='morecontent'
            buildApiUrl={(pageNumber, pagesize)=>removeNullQueryParam(`previewFileContent?uploadId=${open}&limit=${pagesize}&page=${pageNumber}&status=${status}&pnr=${searchParams.get('pnr')}&input_expiry=${searchParams.get('expiry_date') ? dayjs(searchParams.get('expiry_date'), 'YYYY-MM-DD').toDate().toISOString() : null}`)} 
            >
        <Column title="Status"  render={(el:any)=> el.status} /> 
        <Column title="id"  render={(el:any)=> el.id}/> 
        <Column title="Download"  render={(el:any)=> el.downloadPrimaryId ? 'Yes': 'No'}/> 
        
        <Column title="Ticket Type"  render={(el:any)=> (el.date && el.time) ? "Dated" : "Open Date"}/> 
        <Column title="Is Media Code" dataIndex="mediaCode"  render={(el:any)=> (el) ? "Yes" : "No"} />  
        <Column title="Tour" dataIndex="tourname"  />  
        <Column title="PNR" dataIndex="key"  />
        <Column title="QR/Bar Code" dataIndex="qr"  />
        <Column title="Cost" dataIndex="cost"  />
        <Column title="Input Expiry" dataIndex="inputExpiry"  render={(el:any)=>formatDateInTimeZone(el)} />
        <Column title="Expiry" dataIndex="expiry"  render={(el:any)=>formatDateInTimeZone(el)}/>
        <Column title="Ticket Type" dataIndex="ticketType"  />
        <Column title="Date" dataIndex="date"  />
        <Column title="Time" dataIndex="time"  />
        <Column title="Last Update Date" render={(el:any)=>formatDateInTimeZone(el.updated)}/>
        <Column title="Last Action By" dataIndex="updateByName"  />
        
    </DataTable>
    </Drawer>
}

export const TicketInventoryUploadList = () => {
  const { inventoryData, ticketStatusUpdateloading, uploadEntryDeleteLoading, downloadPreviewExcelloading } = useSelector((state: any) => state.ticketInventory);
  let { masterSelectValuesMap } = useSelector((state: any) => state.master);
  masterSelectValuesMap = masterSelectValuesMap || {}
  const dispatch = useDispatch()
  
  const uploadDatatableRef = useRef();
  const [state, setState] = useState<any>({drawer: undefined, selectedRows: [], filter: false});
  const [modal, contextHolder] = Modal.useModal();
  const [searchParams, setSearchParams] = useSearchParams();

  

  useEffect(() => {
    dispatch(getMasterTypeSelectorValue('Trip Ticket Inventory'));
  }, [])



  

  


  const uploadListStatus = searchParams.get('status') || 'Pending';



  

  const handleUploadListStatusChange = (e: any) => {
   
    setSearchParams(buildParam(searchParams, {status: e.target.value}))
  };

  useEffect(() => {
    
    if(uploadDatatableRef.current) 
      (uploadDatatableRef.current as any).refresh()

    setState((st:any)=>({...st, selectedFileRows: []}))

  }, [searchParams]);




return  (

       <>
       {contextHolder}
       {state.filter? <AdvanceFilter open={state.filter}  onClose={()=>setState((old:any) =>({...old, filter: false}))}/>: null}
     {state.drawer? 
    <TicketListPopup open={state.drawer} onClose={() => {
      setState((st:any)=>({...st, drawer: undefined}));
      (uploadDatatableRef.current as any).refresh()
    }} /> 
     : null} 
    <DataTable
            title={<>
            <Radio.Group value={uploadListStatus} defaultValue={uploadListStatus} 
                    onChange={handleUploadListStatusChange}>
                    <Radio.Button value="All">All</Radio.Button>
                    {StatusRadioGroup}
                  </Radio.Group> {" "}
                  <Button type='primary' onClick={()=>setState((old:any) =>({...old, filter: true}))}>Advance Filter</Button> {" "}
                  <Button type='primary' onClick={()=>setSearchParams({})}>Clear Filter</Button>
            </>}  
            key="id" componentuniquekey="datatableuploadfilelist" 
            lazyPagination={true}
            onRefresh={()=> setState((statea:any)=> ({ ...statea, selectedFileRows: []}))}
            ref={uploadDatatableRef}
           
            selectedRows={state.selectedFileRows || []}
            onRowSlection={(selectedRow:any)=>setState((statea:any)=> ({ ...statea, selectedFileRows: selectedRow}))}
            extra={
            <Button 
              onClick={()=>setState((st:any)=>({...st, drawer: state.selectedFileRows.join(',')}))}
              disabled={!(state.selectedFileRows && state.selectedFileRows.length > 0)}>Preview</Button>}

            datatransform={(el:any) => el.map((e:any)=>({...e, extraj: JSON.parse(window.atob(e.extra))}))}
            buildApiUrl={(pageNumber, pagesize)=>removeNullQueryParam(`fetchUploadedFilesDetails?limit=${pagesize}&page=${pageNumber}&status=${uploadListStatus}&product_id=${searchParams.get('productid')}&pnr=${searchParams.get('pnr')}&input_expiry=${searchParams.get('expiry_date') ? dayjs(searchParams.get('expiry_date'), 'YYYY-MM-DD').toDate().toISOString() : null}`)} 
            rowClassName={(record:any) => record.status === 'processeed_error' ? 'error' : ''}
          >
        <Column title="Product Name" dataIndex="extraj" render={(el:any)=>(masterSelectValuesMap[el.inventoryProductId] || {}).masterValue} />
        <Column title="File Name" dataIndex="fileName"  />
        <Column title="Cost Per Ticket" dataIndex="extraj" render={(el:any)=>el.cost} />
        <Column title="Input Expiry" dataIndex="extraj" render={(el:any)=>formatDateInTimeZone(el.expiry)} />
        <Column title="Uploaded By" dataIndex="userName"  />
        <Column title="Uploaded Date" render={(el:any)=>formatDateInTimeZone(el.created)}/>
        <Column title="Pending/Total" render={(el:any)=> ({ 
            props: {
              style: { background: el.pendingCount > 0 ? "#ffbdbd" : "" }
            },
            children: <div>{`${el.pendingCount}/${el.totalCount}`}</div>
          })} />
        
        <Column title="File Process Status" dataIndex="status"  />
        <Column title="Comment" dataIndex="comment" render={(e:any)=><TooltipParagraph style={{width: '75px'}} ellipsis={true}  >{e}</TooltipParagraph>} />
        <Column title="Preview"  render={(el:any)=>
          <Button disabled={el.status === 'processeed_error'} onClick={()=>setState((st:any)=>({...st, drawer: el.id}))}>Preview</Button> } 
        />
        <Column title="Action"  render={(el:any)=>
        <>
        <Popconfirm
          title="Delete Confirmation"
          description="Are you sure, you would like to delete this file?"
          okText="Yes"
          cancelText="No"
          onConfirm={() => dispatch(deleteFileByIdAndComponentName(el)).then(() => {
              if(uploadDatatableRef.current)
                  (uploadDatatableRef.current as any).refresh();
            })}
        >
          <Button 
            loading={uploadEntryDeleteLoading === el.id}
            disabled={el.status !== 'processeed_error' && (el.approvedCount > 0)}
            >
            Delete File
          </Button>
        </Popconfirm>
        </>
        } />
    </DataTable>
     
  </>);
}





